// extracted by css-extract-rspack-plugin
export default {"root":"Pfn9pd"};